import React from "react";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import { HeadingText, HighlightedText, HighlightedTextWrapper } from "./styles";
import { useOnload } from "@utils/useOnLoad";
import { resolvePath } from "@utils/resolvePath";

type HeadingImageConfig = {
  src?: string;
  alt?: string;
  height?: string;
  width?: string;
  marginBottom?: string;
  styles?: React.CSSProperties;
};

type PlansExtensionHeadingProps = {
  text?: string;
  is_visible?: boolean;
  styles?: React.CSSProperties;
  actions?: {
    on_load?: unknown[];
  };
  highlightedText?: string;
  image?: HeadingImageConfig;
};

const mapStateToProps = function (
  state: Record<string, unknown>,
  ownProps: { id: string }
) {
  return getWidgetSpecificProps(
    (state as { configuration?: { normalisedConfig?: unknown } }).configuration
      ?.normalisedConfig,
    ownProps.id
  );
};

const PlansExtensionHeading = (props: PlansExtensionHeadingProps) => {
  const {
    text,
    is_visible,
    styles,
    actions,
    highlightedText,
    image = {}
  } = props;

  const { on_load } = actions || {};

  useOnload({ on_load });

  return is_visible ? (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        ...styles
      }}
    >
      <img
        src={resolvePath(image?.src || "/images/increase-cover.svg")}
        style={{
          marginBottom: image?.marginBottom || "12px",
          ...(image?.styles || {})
        }}
        height={image?.height || "80px"}
        width={image?.width || "80px"}
        alt={image?.alt || "increase cover"}
      />

      {highlightedText ? (
        <HighlightedTextWrapper>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.24219 3.24121C7.25197 6.33112 9.77359 8.83278 12.8828 8.83301L12.8838 8.83203V8.83594H12.8828C9.77367 8.83616 7.25209 11.3379 7.24219 14.4277C7.23259 11.4345 4.86621 8.99259 1.8916 8.84277L1.60156 8.83594V8.83301C4.71097 8.83301 7.2324 6.33126 7.24219 3.24121ZM12.0781 1.62891C12.0781 2.94709 13.145 4.01571 14.4668 4.03125C13.1457 4.04677 12.0792 5.11533 12.0781 6.43262H12.0771C12.0761 5.11526 11.0097 4.04666 9.68848 4.03125C11.0103 4.01583 12.0771 2.94716 12.0771 1.62891C12.0771 1.62728 12.0772 1.62565 12.0771 1.62402H12.0781C12.0781 1.62565 12.0781 1.62728 12.0781 1.62891Z"
              fill="url(#paint0_linear_4132_5702)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_4132_5702"
                x1="15.8716"
                y1="4.42486"
                x2="0.597652"
                y2="4.69775"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#F66969" />
                <stop offset="1" stopColor="#743DDC" />
              </linearGradient>
            </defs>
          </svg>
          <div>
            <HighlightedText>{highlightedText}</HighlightedText>
          </div>
        </HighlightedTextWrapper>
      ) : null}

      <HeadingText>{text}</HeadingText>
    </div>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(PlansExtensionHeading);
